export enum EEvents {
  ON_ARTICLE_LINK_CHANGE = "on-article-link-change",
  ON_RIGHT_SIDEBAR_TOOGLE = "on-right-sidebar-toogle",
  ON_LEFT_SIDEBAR_TOOGLE = "on-left-sidebar-toogle",
}
